/**
 * Animation timeline used by the canvas stage.
 *
 * Real-time effects (flash decay, floating text, camera shake) should continue to
 * expire against wall-clock time, while hit-stop freezes animation frame
 * advancement for a few milliseconds. This tiny clock separates those concerns:
 * callers pass real time and whether animation is currently paused; the returned
 * value is the accumulated unpaused animation time.
 */
export class AnimationTimeline {
  private lastRealNow: number;
  private animationNow = 0;

  constructor(startRealNow = 0) {
    this.lastRealNow = startRealNow;
  }

  tick(realNow: number, paused: boolean): number {
    const delta = Math.max(0, realNow - this.lastRealNow);
    if (!paused) this.animationNow += delta;
    this.lastRealNow = realNow;
    return this.animationNow;
  }

  now(): number {
    return this.animationNow;
  }

  reset(realNow = 0): void {
    this.lastRealNow = realNow;
    this.animationNow = 0;
  }
}
